import Axios, { AxiosResponse } from "axios";
var _token: string = "";

Axios.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    let code =
      error && error.response && error.response.status
        ? error.response.status
        : 0;

    switch (code) {
      case 401:
        return Promise.resolve({
          data: {
            success: false,
            error: {
              code: code,
              message: "Usuário logado não possui permissão",
            },
            messages: [
              {
                index: 0,
                message: "Usuário logado não possui permissão",
              },
            ],
          },
        });
      default:
        return Promise.reject(error);
    }
  }
);

class BaseService {
  setToken = (token: string) => {
    _token = token;
  };

  getToken = () => {
    return _token;
  };

  get = async (endpoint: string, token: string) => {
    var config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    return await Axios.get(endpoint, config);
  };

  post = async (endpoint: string, token: string, data: any) => {
    var config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    return await Axios.post(endpoint, data, config);
  };

  put = async (endpoint: string, data: any, token: string) => {
    var config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    return await Axios.put(endpoint, data, config);
  };

  delete = async (endpoint: string, token: String, data: Array<any>) => {
    return await Axios.delete(endpoint, { data: { saleIds: data } });
  };
}

export default BaseService;
